import { COMMERCE_LISTED_ZONES_ID_MAX } from '../../../../services/commerceService.ts';
import type { CommerceDepartmentCity } from '../../../../services/commerceService.ts';

export type ListedZonesState = {
  ids: string[];
  labels: Record<string, string>;
};

export const listedZonesInitial: ListedZonesState = { ids: [], labels: {} };

export function profileZoneFromListedZones(ids: string[], labels: Record<string, string>) {
  if (!ids.length) return '';
  const parts = ids.map((id) => labels[id] ?? id);
  const s = parts.join(', ');
  return s.length > 280 ? `${s.slice(0, 277)}…` : s;
}

export type ListedZonesAction =
  | { type: 'toggle'; id: string; name?: string }
  | { type: 'remove'; id: string }
  | { type: 'clear' }
  | { type: 'mergeLabels'; cities: CommerceDepartmentCity[] }
  | { type: 'replace'; ids: string[]; labels: Record<string, string> };

export function listedZonesReducer(state: ListedZonesState, action: ListedZonesAction): ListedZonesState {
  if (action.type === 'replace') {
    return { ids: [...action.ids], labels: { ...action.labels } };
  }
  if (action.type === 'clear') return listedZonesInitial;
  if (action.type === 'remove') {
    if (!state.ids.includes(action.id)) return state;
    const labels = { ...state.labels };
    delete labels[action.id];
    return { ids: state.ids.filter((x) => x !== action.id), labels };
  }
  if (action.type === 'mergeLabels') {
    const next = { ...state.labels };
    let changed = false;
    for (const c of action.cities) {
      if (state.ids.includes(c.id) && next[c.id] == null) {
        next[c.id] = c.name;
        changed = true;
      }
    }
    if (!changed) return state;
    return { ...state, labels: next };
  }
  const { id, name } = action;
  const idx = state.ids.indexOf(id);
  if (idx >= 0) {
    const labels = { ...state.labels };
    delete labels[id];
    return { ids: state.ids.filter((_, i) => i !== idx), labels };
  }
  if (state.ids.length >= COMMERCE_LISTED_ZONES_ID_MAX) return state;
  const labels = { ...state.labels };
  if (name) labels[id] = name;
  return { ids: [...state.ids, id], labels };
}
